var _circle, _circle2, _circle3, _circle4, _circle5, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5806,
    cy: 6.63403,
    r: 1,
    fill: "#233A80"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5806,
    cy: 11.634,
    r: 1,
    fill: "#233A80"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5806,
    cy: 18.634,
    r: 1,
    fill: "#233A80"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5806,
    cy: 15.634,
    r: 1,
    fill: "#233A80"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.58057,
    cy: 11.634,
    r: 1,
    fill: "#233A80"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7875 6.63403L6.58057 11.134L10.7185 15.5373L16.9254 18.634L18.5806 11.6663L12.7875 6.63403Z",
    stroke: "#233A80",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5806 0.634033L12.3901 12.3927M12.3901 12.3927L5.08057 23.634M12.3901 12.3927L20.5806 23.634M12.3901 12.3927L24.5806 10.134M12.3901 12.3927L0.580566 10.134",
    stroke: "#233A80",
    strokeWidth: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5806 0.634033L0.580566 9.98997L4.83863 23.634H20.3225L24.5806 9.98997L12.5806 0.634033Z",
    stroke: "#233A80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpider);
export default __webpack_public_path__ + "static/media/spider.a4b24be8f81e4b3d45ce6943defb98df.svg";
export { ForwardRef as ReactComponent };